import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, typography }) => ({
  actions: {
    marginTop: spacing(1.5),
    marginBottom: spacing(1.5)
  },
  summary: {
    padding: spacing(1),
    height: typography.pxToRem(206),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  subtitle: {
    lineClamp: 2,
    WebkitLineClamp: 2
  },
  title: {
    minHeight: 'auto'
  },
  root: {
    height: typography.pxToRem(345),
    margin: 'auto'
  },
  card: {
    height: '100%'
  }
}))
